<script>
    export let cell;
    export let header;
    export let headerOptions = {};
</script>

<td class={headerOptions[header]?.cellClass || headerOptions[header]?.class || ''}>
    {@html cell}
</td>

<style>
    td.numeric {
        font-variant: oldstyle-nums tabular-nums;
        text-align: right;
    }

    td.nowrap {
        white-space: nowrap;
    }
</style>
